import { ScrollableRadioList, ScrollableRadioListProps } from '@almbrand/scrollableradiolist';
import { ThemeUnion } from '@almbrand/systemicons/dist/cjs/types/icon';
import { PageContext } from 'context/PageContext';
import { useContext } from 'react';
import { FieldValues, UseFormRegister } from 'react-hook-form';

export interface ScrollableRadioListComponentProps extends ScrollableRadioListProps<ThemeUnion> {
	register: UseFormRegister<FieldValues>;
	contentType: string;
	submitStep?: () => void;
	stepTitle?: string;
}

export const ScrollableRadioListComponent: React.FC<ScrollableRadioListComponentProps> = ({
	register,
	submitStep,
	name,
	contentType,
	...props
}) => {
	const pageContext = useContext(PageContext);
	const { theme } = pageContext ?? {};
	const { onChange, name: scrollableRadioListName } = register(name, { required: true });

	const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const { value } = event.currentTarget;

		onChange({
			target: {
				name: scrollableRadioListName,
				value: {
					id: name,
					value: value,
					type: contentType,
					stepTitle: props.stepTitle,
				},
			},
		});
		submitStep?.();
	};
	return (
		<ScrollableRadioList
			{...props}
			themeName={theme}
			onChange={handleOnChange}
		/>
	);
};
